import { PositionRequestDTO } from '@pya-mms/common';

const isCurrentPosition = (position: PositionRequestDTO): boolean => !position.EndYear;

/** Current roles first, then by StartYear descending (newest first). */
export const sortYachtPositions = (positions: PositionRequestDTO[]): PositionRequestDTO[] =>
  [...positions].sort((a, b) => {
    const aCurrent = isCurrentPosition(a);
    const bCurrent = isCurrentPosition(b);
    if (aCurrent !== bCurrent) return aCurrent ? -1 : 1;
    return b.StartYear - a.StartYear;
  });
